import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getCalendarOwnerFromItem from 'owa-calendar-forms-common/lib/utils/getCalendarOwnerFromItem';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';

export const getFrom = (): EmailAddressWrapper => {
    const event = getComposeEvent(null /* formId */);
    return getCalendarOwnerFromItem(event);
};
